'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ModalContent = require('./ModalContent');

var _ModalContent2 = _interopRequireDefault(_ModalContent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Modal = function (_React$Component) {
  _inherits(Modal, _React$Component);

  _createClass(Modal, null, [{
    key: '_handleOnClickContent',
    value: function _handleOnClickContent(e) {
      e.stopPropagation();
    }
  }]);

  function Modal(props) {
    _classCallCheck(this, Modal);

    var _this = _possibleConstructorReturn(this, (Modal.__proto__ || Object.getPrototypeOf(Modal)).call(this, props));

    _this.componentDidMount = function () {
      document.addEventListener('keydown', _this._handleOnKeyPressed);
    };

    _this.componentWillUnmount = function () {
      _this.hide();
    };

    _this._handleOnKeyPressed = function (e) {
      var hide = _this.state.hide;
      var allowClose = _this.props.allowClose;


      if (!hide && allowClose && e.which === 27) {
        e.preventDefault();
        _this.hide();
      }
    };

    _this.show = function () {
      _this.setState({ hide: false });
      if (document && document.body) {
        document.body.classList.add('pxl-modal-body');
      }
    };

    _this.hide = function () {
      _this.setState({ hide: true });
      if (document && document.body) {
        document.body.classList.remove('pxl-modal-body');
      }
      if (_this.props.onClose) {
        _this.props.onClose();
      }
    };

    _this._handleOnClick = function (e) {
      if (_this.props.allowClose) {
        _this.hide();
      }
    };

    _this.state = {
      hide: true
    };
    return _this;
  }

  _createClass(Modal, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          children = _props.children,
          id = _props.id,
          displayCloseButton = _props.displayCloseButton;
      var hide = this.state.hide;


      return _react2.default.createElement(
        'div',
        {
          id: id,
          className: className + ' pxl-modal' + (hide ? ' pxl-modal--hidden' : ''),
          onClick: this._handleOnClick
        },
        _react2.default.createElement(
          _ModalContent2.default,
          {
            id: id,
            onIgnore: Modal._handleOnClickContent,
            onClose: this._handleOnClick,
            displayCloseButton: displayCloseButton
          },
          children
        )
      );
    }
  }]);

  return Modal;
}(_react2.default.Component);

exports.default = Modal;


Modal.propTypes = {
  allowClose: _propTypes2.default.bool,
  className: _propTypes2.default.string,
  displayCloseButton: _propTypes2.default.bool,
  id: _propTypes2.default.string,
  onClose: _propTypes2.default.func
};

Modal.defaultProps = {
  allowClose: true,
  className: '',
  displayCloseButton: false,
  id: 'modal',
  onClose: undefined
};